export default __webpack_public_path__ + "static/media/wine-behind-greenery.6f25e7d0.png";